







































































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import { excursions } from "@/config/host.config";
import { IExcursionCategory as ICategory } from "@/@types/excursions/excursions";
import { IExcursion } from "@/@types/excursions/excursions";
import { deleteElement } from "@/api/delite/delite-element";
import { AxiosError } from "axios";

import ExcursionList from "@/components/card/excursion/excursion-list.vue";
import ExcursionsHeader from "@/components/card/excursion/addition/excursions-header.vue";
import StandartCategoryTab from "@/components/app/dropdowns/standart-category-tab.vue";
import FullExcursionCard from "@/components/card/excursion/full-excursion-card.vue";
import ExcursionTicket from "@/components/card/excursion/excursion-ticket.vue";
import ChangeExcursionForm from "@/components/card/excursion/change-excursion-form.vue";
import ExcursionCategorys from "@/components/card/excursion/categorys/excursion-categorys.vue";
import StandartCategoryForm from "@/components/app/dropdowns/standart-category-form.vue";

@Component({
  components: {
    ExcursionList,
    "e-header": ExcursionsHeader,
    "categorys-tab": StandartCategoryTab,
    FullExcursionCard,
    ExcursionTicket,
    ChangeExcursionForm,
    ExcursionCategorys,
    "cat-form": StandartCategoryForm,
  },
})
export default class ExcursionsPage extends Vue {
  @Provide() categoryFolder = "excursion/categorys/posters";
  @Provide() categoryBgFolder = "excursion/categorys/background";

  @Provide() excursionFolder = "excursion/posters";
  @Provide() excursionBgFolder = "excursion/background";

  categorys: Array<ICategory> = [];
  excursions: Array<IExcursion> = [];

  categoryDeleted = false;
  excursionDeleted = false;

  category_id = "";
  excursion_id = "";
  search = "";

  get excursion(): IExcursion | null {
    const exc = this.excursions.find((el) => el._id === this.excursion_id);
    return exc ? exc : null;
  }

  get category(): ICategory | null {
    const exc = this.categorys.find((el) => el._id === this.category_id);
    return exc ? exc : null;
  }

  changeCatDeleted(toogle: boolean): void {
    this.categoryDeleted = toogle;
    this.createCategoryList();
  }

  isExcOpen(id: string): void {
    this.excursion_id = id;
    this.$nextTick(() => this.$bvModal.show("excursion"));
  }

  //warn; info
  loger(method: string, code: string, page: string): void {
    let text = this.$i18n.t("alerts.emptyUpdate");
    const name = this.$i18n.tc(`${page}.name`, method == "get" ? 2 : 1);
    if (
      code == "0" ||
      code == "200" ||
      code == "404" ||
      code == "403" ||
      code == "500"
    )
      text = this.$i18n.t(`notify.${method}.${code}`, { name });

    const type = code == "200" ? "info" : "warn";
    this.$notify({
      group: "global",
      text: String(text),
      type: type,
    });
  }

  @Watch("categoryDeleted")
  async createCategoryList(): Promise<void> {
    const uri = excursions.category;
    const params = { "match[deleted][value]": this.categoryDeleted };
    try {
      const catres = await this.$axios.get(uri, { params });
      if (catres.status === 200) this.categorys = catres.data;
    } catch (e) {
      console.error(e);
    }
  }

  catMustChange(id: string): void {
    this.category_id = id;
    this.$nextTick(() => this.$bvModal.show("change-exc-category"));
  }

  deleteCategory(id: string): void {
    if (!id) return this.loger("delete", "404", "categorys");
    const uri = this.categoryDeleted
      ? excursions.categoryForse
      : excursions.category;

    deleteElement(id, uri)
      .then(() => {
        this.loger("delete", "200", "categorys");
        const i = this.categorys.findIndex((cat) => cat._id == id);
        if (i < 0) return this.createCategoryList();
        this.categorys.splice(i, 1);
      })
      .catch((e: AxiosError) =>
        this.loger("delete", e.code ? e.code : "0", "categorys")
      );
  }

  @Watch("excursionDeleted")
  async createExcursions(): Promise<void> {
    this.excursions = [];
    const params = { "match[deleted][value]": this.excursionDeleted };
    try {
      const res = await this.$axios.get(excursions.mainAPI, { params });
      if (res.status === 200) this.excursions = res.data;
    } catch (e: AxiosError | unknown) {
      if (e instanceof AxiosError)
        this.loger("get", e.code ? e.code : "0", "Excursion");
      console.error(e);
    }
  }

  async restoreExc(id: string): Promise<void> {
    if (!this.excursionDeleted) return;
    const uri = excursions.excursionRestore + "/" + id;
    try {
      const res = await this.$axios.put(uri);
      if (res.status === 200) {
        this.loger("restore", "200", "Excursion");
        this.excursionsCleaner(id);
      }
    } catch (e: AxiosError | unknown) {
      if (e instanceof AxiosError)
        this.loger("restore", e.code ? e.code : "0", "Excursion");
      console.error(e);
    }
  }

  async changeExc(data: Partial<IExcursion>, id: string): Promise<void> {
    const method = id ? "put" : "post";
    const uri = id ? excursions.mainAPI + "/" + id : excursions.mainAPI;

    try {
      const res = await this.$axios[method](uri, data);
      if (res.status === 200) {
        this.loger(method, "200", "Excursion");
        this.$bvModal.hide("change-excursion-form");
        const i = this.excursions.findIndex((el) => el._id === id);
        if (i < 0) return this.createExcursions();
        this.$set(this.excursions, i, res.data);
      }
    } catch (e: AxiosError | unknown) {
      if (e instanceof AxiosError)
        this.loger(method, e.code ? e.code : "0", "Excursion");
      console.error(e);
    }
  }

  deleteExcursion(id: string | undefined): void {
    if (!id) return this.loger("delete", "404", "Excursion");
    const uri = this.excursionDeleted
      ? excursions.excursionForse
      : excursions.mainAPI;

    deleteElement(id, uri)
      .then(() => {
        this.loger("delete", "200", "Excursion");
        this.excursionsCleaner(id);
      })
      .catch((e: AxiosError) =>
        this.loger("delete", e.code ? e.code : "0", "Excursion")
      );
  }

  async excursionsCleaner(id: string): Promise<void> {
    const i = this.excursions.findIndex((e) => e._id == id);
    if (i < 0) return this.createExcursions();
    this.excursions.splice(i, 1);
  }

  async dropCollection(): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("main.confirms.delete-all")),
        }
      );

      if (result === true) {
        this.excursions.forEach((exc) => this.deleteExcursion(exc._id));
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async dropCategoryCollection(): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("main.confirms.delete-all")),
        }
      );

      if (result === true) {
        this.categorys.forEach((exc) => this.deleteCategory(exc._id));
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async changeCategory(data: Partial<ICategory>, id: string): Promise<void> {
    const method = id ? "put" : "post";
    const uri = id ? excursions.category + "/" + id : excursions.category;
    try {
      const cat_res = await this.$axios[method](uri, data);
      if (cat_res.status === 200) {
        this.loger(method, "200", "categorys");
        this.$bvModal.hide("change-exc-category");
        if (!id) {
          this.categorys.push(cat_res.data);
          return;
        }
        const i = this.categorys.findIndex((cat) => cat._id == id);
        if (i < 0) return this.createCategoryList();
        this.$set(this.categorys, i, cat_res.data);
      }
    } catch (e: AxiosError | unknown) {
      if (e instanceof AxiosError)
        this.loger(method, e.code ? e.code : "0", "categorys");
      console.error(e);
    }
  }

  updateCategorySortOrders(arr: Array<ICategory>): void {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].sort_order != i)
        this.changeCategory({ sort_order: i }, arr[i]._id);
    }
  }

  async restoreCategory(id: string): Promise<void> {
    const uri = excursions.categoryRestore + "/" + id;

    try {
      const result = await this.$axios.put(uri);
      if (result.status === 200) {
        this.loger("restore", "200", "categorys");

        const i = this.categorys.findIndex((el) => el._id == id);
        if (i < 0) return this.createCategoryList();
        this.categorys.splice(i, 1);
      }
    } catch (e: AxiosError | unknown) {
      if (e instanceof AxiosError)
        this.loger("restore", e.code ? e.code : "0", "categorys");
      console.error(e);
    }
  }

  mounted(): void {
    this.createCategoryList();
    this.createExcursions();
  }
}
